import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  HStack,
  Image,
  SkeletonText,
  Text,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import Logo from "../../../assets/colorLogo.png";
// import menu from '../../../assets/icons/menu.svg'
import { AiOutlineGroup } from "react-icons/ai";
import { BiCalendarEvent } from "react-icons/bi";
import { BsPeople, BsPersonWorkspace } from "react-icons/bs";
import { CiHashtag, CiSquareQuestion } from "react-icons/ci";
import { FaRegFileAlt } from "react-icons/fa";
import { FaRegFileLines, FaRegFilePdf } from "react-icons/fa6";
import { GiEmptyWoodBucketHandle } from "react-icons/gi";
import { GoDeviceCameraVideo } from "react-icons/go";
import { HiOutlineUserGroup } from "react-icons/hi";
import { IoFileTrayFull } from "react-icons/io5";
import { LuDollarSign } from "react-icons/lu";
import { MdOutlineAssessment } from "react-icons/md";
import { PiExam, PiFilesBold, PiIntersectThree } from "react-icons/pi";
import { RiFile2Fill, RiFileExcel2Line } from "react-icons/ri";
import { RxFileText } from "react-icons/rx";
import { TbBasketQuestion } from "react-icons/tb";
import { useSelector } from "react-redux";
const SuperAdminSidenavbar = () => {
  const isLoading = useSelector((state) => state.user.isLoading);

  let navTabs = [
    {
      mainLabel: "المستخدمين",
      icon: <HiOutlineUserGroup size={24} />,
      children: [
        {
          label: "المعلمين",
          link: "/dashboard/superadmin-teachers",
          icon: <BsPersonWorkspace size={24} />,
        },
        {
          label: " المجموعات",
          link: "/dashboard/superadmin-groups",
          icon: <AiOutlineGroup size={24} />,
        },
        {
          label: " الطلاب",
          link: "/dashboard/superadmin-students",
          icon: <BsPeople size={24} />,
        },
      ],
    },
    {
      mainLabel: "تقسيم المنهج",
      icon: <IoFileTrayFull size={24} />,
      children: [
        {
          label: "الفصول",
          link: "/dashboard/superadmin-chapters",
          icon: <FaRegFileAlt size={24} />,
        },
        {
          label: "الاقسام",
          link: "/dashboard/superadmin-sections",
          icon: <PiIntersectThree size={24} />,
        },
      ],
    },
    {
      mainLabel: "المحتوي التعليمي",
      icon: <RxFileText size={24} />,
      children: [
        {
          label: " المواد الدراسية",
          link: "/dashboard/superadmin-subjects",
          icon: <PiFilesBold size={24} />,
        },
        {
          label: "الدورات ",
          link: "/dashboard/superadmin-courses",
          icon: <FaRegFileLines size={24} />,
        },

        {
          label: " العلامات",
          link: "/dashboard/superadmin-tags",
          icon: <CiHashtag size={24} />,
        },
        {
          label: " المجموعات",
          link: "/dashboard/superadmin-groups",
          icon: <AiOutlineGroup size={24} />,
        },
        {
          label: "الفيديوهات",
          link: "/dashboard/superadmin-videos",
          icon: <GoDeviceCameraVideo size={24} />,
        },
        {
          label: "الفيديوهات المباشرة",
          link: "/dashboard/superadmin-live-videos",
          icon: <GoDeviceCameraVideo size={24} />,
        },
        {
          label: "PDFs",
          link: "/dashboard/superadmin-pdfs",
          icon: <FaRegFilePdf size={24} />,
        },
        {
          label: " مجموعات الاسئلة",
          link: "/dashboard/superadmin-buckets",
          icon: <GiEmptyWoodBucketHandle size={24} />,
        },
        {
          label: " بنك الاسئلة",
          link: "/dashboard/superadmin-questions-bank",
          icon: <TbBasketQuestion size={24} />,
        },
        {
          label: "الاختبارات",
          link: "/dashboard/superadmin-exams",
          icon: <PiExam size={24} />,
        },
        {
          label: "الواجبات",
          link: "/dashboard/superadmin-homework",
          icon: <PiExam size={24} />,
        },
      ],
    },

    {
      mainLabel: " طلبات الطلاب",
      icon: <CiSquareQuestion size={24} />,
      children: [
        {
          label: "مشاهدة الفيديو",
          link: "/dashboard/superadmin-videos-view-requests",
          icon: <BsPeople size={24} />,
        },
        {
          label: " اعادة الاختبار",
          link: "/dashboard/exam-redo-requests",
          icon: <BsPeople size={24} />,
        },
      ],
    },
    {
      mainLabel: " الدفع",
      icon: <LuDollarSign size={24} />,
      children: [
        {
          label: "الحصص / الشهور",
          link: "/dashboard/superadmin-payment",
          icon: <BiCalendarEvent size={24} />,
        },
        {
          label: "  كورسات",
          link: "/dashboard/superadmin-course-enrolls",
          icon: <PiFilesBold size={24} />,
        },
        {
          label: " الطلاب",
          link: "/dashboard/superadmin-students-payments",
          icon: <BsPeople size={24} />,
        },
      ],
    },
    {
      mainLabel: "التقارير",
      icon: <MdOutlineAssessment size={24} />,
      children: [
        {
          label: " الفيديوهات المباشرة",
          link: "/dashboard/superadmin-live-videos-reports",
          icon: <GoDeviceCameraVideo size={24} />,
        },
        {
          label: " مراجعة الواجبات",
          link: "/dashboard/uncomment-homework-report",
          icon: <PiExam size={24} />,
        },
        {
          label: "تقرير الحضور",
          link: "/dashboard/attendence-report",
          icon: <RiFile2Fill size={24} />,
        },
        {
          label: " غياب الامتحانات",
          link: "/dashboard/exam-attendence-report",
          icon: <RiFile2Fill size={24} />,
        },
        {
          label: " حضور الامتحانات",
          link: "/dashboard/exam-report",
          icon: <RiFile2Fill size={24} />,
        },
        {
          label: " غياب الواجبات",
          link: "/dashboard/homework-absent-report",
          icon: <RiFile2Fill size={24} />,
        },
        // {
        //   label: " حضور الواجبات",
        //   link: "/dashboard/homework-attendence-report",
        //   icon: <RiFile2Fill size={24} />,
        // },
        {
          label: "تقرير المجموعات",
          link: "/dashboard/groups-report",
          icon: <RiFile2Fill size={24} />,
        },
        {
          label: " تقرير مشاهدات الفيديوهات",
          link: "/dashboard/videos-report",
          icon: <RiFile2Fill size={24} />,
        },
        {
          label: "تقرير غياب المشاهدات",
          link: "/dashboard/videos-absent-report",
          icon: <RiFile2Fill size={24} />,  
        },
        {
          label: "تقرير طباعة الاسئلة",
          link: "/dashboard/print-all-questions",
          icon: <RiFile2Fill size={24} />,
        },
        {
          label: " تقرير عدم الدفع",
          link: "/dashboard/unpaid-report",
          icon: <RiFile2Fill size={24} />,
        },
        {
          label: "تقرير مراجعة الواجبات",
          link: "/dashboard/uncomment-homework-report",
          icon: <RiFile2Fill size={24} />,
        },
    
        {
          label: " تقرير الدفع",
          link: "/dashboard/paid-report",
          icon: <RiFile2Fill size={24} />,
        },
        {
          label: "رصد درجات السنتر",
          link: "/dashboard/attendence-simple-report",
          icon: <RiFile2Fill size={24} />,
        },
      ],
    },
  ];

  return (
    <Flex
      w={{ base: "10%", lg: "20%" }}
      h="100vh"
      flexDirection={"column"}
      zIndex="100"
      position="fixed"
      bg="#f5f5f5"
      px={{ base: "0", lg: "20px" }}
      borderLeft="1px solid #45424226"
      alignItems={{ base: "center", lg: "flex-start" }}
      className="scroll"
    >
      <Image
        alignSelf="center"
        my="20px"
        w="50%"
        loading="lazy"
        src={Logo}
        alt="Enough"
        onClick={() => window.location.replace("/")}
      />

      {isLoading ? (
        <HStack w="100%" bg="transparent" h="100%">
          <SkeletonText
            startColor="gray.100"
            endColor="gray.600"
            w="80%"
            mt="4"
            noOfLines={7}
            spacing="20"
          />
        </HStack>
      ) : (
        navTabs?.map((data, index) => {
          return data?.mainLabel ? (
            <Accordion allowMultiple w="100%" py={{ base: "0", lg: "15px" }}>
              <AccordionItem border={0} w="100%">
                <h2 style={{ border: 0 }}>
                  <AccordionButton
                    justifyContent="space-between"
                    outline={0}
                    _active={{
                      outline: "0",
                    }}
                    _focus={{
                      outline: "0",
                    }}
                  >
                    <Box
                      textAlign="left"
                      display="flex"
                      alignItems="center"
                      gap={3}
                    >
                      {data?.icon}{" "}
                      <Text
                        style={{ fontSize: "18px", fontWeight: "500" }}
                        display={{ base: "none", lg: "block" }}
                      >
                        {data?.mainLabel}
                      </Text>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel p={0} pb={4}>
                  {data?.children?.map((val, childIndex) => (
                    <Link
                      to={val.link}
                      key={`${index}-${childIndex}`}
                      style={{ width: "90%" }}
                    >
                      <Flex
                        w="100%"
                        color="black"
                        alignItems="center"
                        justifyContent={{ base: "center", lg: "flex-start" }}
                        mt="10px"
                        p={{ base: "0", lg: "25px" }}
                        cursor="pointer"
                        h={{ base: "60px", lg: "" }}
                        bg={
                          window.location.pathname == val.link
                            ? "#e4e4e4"
                            : "transparent"
                        }
                        borderRadius="15px"
                        fontWeight={
                          window.location.pathname == val.link ? "600" : "400"
                        }
                        _hover={{
                          bg: "#e4e4e4",
                          fontWeight: "600",
                        }}
                      >
                        {val?.icon}
                        <Text
                          fontSize="18px"
                          mx="20px"
                          mt="2px"
                          display={{ base: "none", lg: "block" }}
                          color="main_1"
                        >
                          {val.label}
                        </Text>
                      </Flex>
                    </Link>
                  ))}
                </AccordionPanel>
              </AccordionItem>
            </Accordion>
          ) : (
            <Link to={data.link} key={index} style={{ width: "90%" }}>
              <Flex
                w="100%"
                color="black"
                alignItems="center"
                justifyContent={{ base: "center", lg: "flex-start" }}
                mt="10px"
                p={{ base: "0", lg: "25px" }}
                cursor={"pointer"}
                h={{ base: "60px", lg: "" }}
                bg={
                  window.location.pathname == data.link
                    ? "#e4e4e4"
                    : "transparent"
                }
                // borderRadius="15px"
                fontWeight={
                  window.location.pathname == data.link ? "600" : "500"
                }
                _hover={{
                  bg: "#e4e4e4",
                  fontWeight: "600",
                }}
              >
                {data?.icon}
                <Text
                  fontSize="18px"
                  mx="20px"
                  mt="2px"
                  display={{ base: "none", lg: "block" }}
                  color="main_1"
                >
                  {data.label}
                </Text>
              </Flex>
            </Link>
          );
        })
      )}
    </Flex>
  );
};

export default SuperAdminSidenavbar;
